<div class="header">
  <div class="left-icons">
    <button (click)="onClose()" mat-icon-button aria-label="Back">
      <mat-icon title="Back">arrow_back</mat-icon>
    </button>
  </div>
  <div class="title">Activities</div>
  <div class="right-icons">
    <button type="button" class="mat-inline-button" mat-button color="primary" (click)="saveAll()"
    [disabled]="!lineItems?.length">Done</button>
  </div>
</div>

<div class="body">
  @if (initialized) {
    <!-- Lineitem Forms -->
    @for (li of lineItems; track li) {
      <section>
        <div class="row">
          <div (click)="selectLineItem(li)">
            <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{'activity': li}"></ng-container>
          </div>
          <div class="icons">
            <button mat-icon-button (click)="delete(li)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </section>
    }
    <!-- /Lineitem Forms -->
    <!-- Add lineitem -->
    <section>
      <button mat-icon-button (click)="addLineItem()" color="primary">
        <mat-icon>add</mat-icon> Add activity
      </button>
    </section>
    <!-- /Add lineitem -->
  }
</div>

@if (initialized) {
  <div class="footer">
    @if (selectedItem) {
      <app-report-item-toolbar [lineItem]="selectedItem" [project]="project"
      (changed)="onLineItemChange($event)" [tools]="tools"></app-report-item-toolbar>
    }
  </div>
}


<ng-template #SingleForm let-activity="activity">
  <form [formGroup]="activity._inputForm">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
    </section>

    <section>
      <mat-form-field>
        <input matInput type="text" autocomplete="off" formControlName="title" [errorStateMatcher]="matcher" />
        @if (activity._inputForm.controls.title.hasError('required')) {
          <mat-error>
            This field is required
          </mat-error>
        }
        @if (activity._inputForm.controls.title.hasError('error')) {
          <mat-error>
            {{activity._inputForm.controls.title.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
  </form>
  <ng-container [ngTemplateOutlet]="readOnlyToolbarItems" [ngTemplateOutletContext]="{'li': activity}"></ng-container>

</ng-template>



<ng-template #readOnlyToolbarItems let-li="li">
  @if (li.pictures.length) {
    <section>
      <div class="mat-body-2">Pictures:</div>
      <div class="preview-list">
        @for (pic of li.pictures; track pic) {
          <div>
            <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, li.pictures, pic)" />
          </div>
        }
      </div>
    </section>
  }

  @if (li.annotations.length) {
    <section>
      <div class="mat-body-2">Annotations:</div>
      <div class="preview-list">
        @for (ann of li.annotations; track ann) {
          <div>
            <img [src]="ann.getThumbnail()" class="link" />
          </div>
        }
      </div>
    </section>
  }

  @if (!li.location.isEmpty) {
    <section>
      <div class="mat-body-2">Location:</div>
      <div>
        <app-location-picker [isDialog]="false" [latitude]="li.location.lat" [longitude]="li.location.lng" height="100px"
        [readOnly]="true"></app-location-picker>
      </div>
    </section>
  }
</ng-template>